// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal-slider {
  width: 100%;
  max-width: 950px;
  height: 150px;
}
.example-thumb.example-thumb-0 {
  display: none;
}
.example-track {
  position: relative;
}
.example-mark.example-mark-active {
  color: #f1b24f;
}
.example-mark.example-mark-active.span-1::after {
  color: #f1b24f;
  font-size: 7rem;
}

.example-mark.example-mark-completed.span-1::after {
  color: #f1b24f;
  font-size: 7rem;
}

.example-mark.example-mark-active.span-2::after {
  color: #f1b24f;
  font-size: 7rem;
}

.example-mark.example-mark-completed.span-2::after {
  color: #f1b24f;
  font-size: 7rem;
}

.example-mark.example-mark-active.span-3::after {
  color: #f1b24f;
}

.example-mark.example-mark-completed.span-3::after {
  color: #f1b24f;
}

.example-mark.example-mark-active.span-4::after {
  color: #f1b24f;
}

.example-mark.example-mark-completed.span-4::after {
  color: #f1b24f;
}
.slider-wp {
  display: flex;
  align-items: center;
  text-transform: uppercase;
}
.slider-wp p {
  margin-bottom: 0;
}
.w-2 {
  width: 0.5rem;
}
.french-width {
  width: 10.5rem;
}
.number-label {
  font-size: 5rem;
}

@media (min-width: 1280px) {
  .number-label {
    font-size: 8rem;
  }
  .text-label {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
@media (max-width: 980px) {
  .card-custom {
    width: 100%;
  }
}

@media (max-width: 880px) {
  .horizontal-slider {
    display: none;
  }
}

@media (max-width: 780px) {
  img.card-img-top {
    width: 100%;
    min-height: auto;
  }

  .check-mark {
    right: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Slider/slider.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".horizontal-slider {\n  width: 100%;\n  max-width: 950px;\n  height: 150px;\n}\n.example-thumb.example-thumb-0 {\n  display: none;\n}\n.example-track {\n  position: relative;\n}\n.example-mark.example-mark-active {\n  color: #f1b24f;\n}\n.example-mark.example-mark-active.span-1::after {\n  color: #f1b24f;\n  font-size: 7rem;\n}\n\n.example-mark.example-mark-completed.span-1::after {\n  color: #f1b24f;\n  font-size: 7rem;\n}\n\n.example-mark.example-mark-active.span-2::after {\n  color: #f1b24f;\n  font-size: 7rem;\n}\n\n.example-mark.example-mark-completed.span-2::after {\n  color: #f1b24f;\n  font-size: 7rem;\n}\n\n.example-mark.example-mark-active.span-3::after {\n  color: #f1b24f;\n}\n\n.example-mark.example-mark-completed.span-3::after {\n  color: #f1b24f;\n}\n\n.example-mark.example-mark-active.span-4::after {\n  color: #f1b24f;\n}\n\n.example-mark.example-mark-completed.span-4::after {\n  color: #f1b24f;\n}\n.slider-wp {\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n}\n.slider-wp p {\n  margin-bottom: 0;\n}\n.w-2 {\n  width: 0.5rem;\n}\n.french-width {\n  width: 10.5rem;\n}\n.number-label {\n  font-size: 5rem;\n}\n\n@media (min-width: 1280px) {\n  .number-label {\n    font-size: 8rem;\n  }\n  .text-label {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n}\n@media (max-width: 980px) {\n  .card-custom {\n    width: 100%;\n  }\n}\n\n@media (max-width: 880px) {\n  .horizontal-slider {\n    display: none;\n  }\n}\n\n@media (max-width: 780px) {\n  img.card-img-top {\n    width: 100%;\n    min-height: auto;\n  }\n\n  .check-mark {\n    right: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
